import { Inject, Injectable } from 'ng-metadata/core';
import * as angular from 'angular';

/**
 * @ngdoc service
 * @name mwDatePickerDialogService
 * @module mw.components.datePicker
 * @description
 * A service that is used to open a date picker in a modal
 */

 /**
  * @ngdoc method
  * @name mwDatePickerDialogService#show
  * @param {object} [dialogOptions] - An object containing configuration options for the $mdDialog.  Example:
  * <hljs hljs-language="js">
  *   {
  *      parentElement: Object,
  *      targetEvent: Object
  *   }
  * </hljs>
  * @param {object} [datePickerOptions] - An object containing configuration options for the mw-date-picker component.  Example:
  * <hljs hljs-language="js">
  *   {
  *      minView: 'Month',
  *      maxView: 'Month',
  *      startView: 'Month',
  *      locale: 'en',
  *      timezone: 'America/New_York',
  *
  *   }
  * </hljs>
  *
  * @returns {Date} The selected Date
  */
@Injectable('mwDatePickerDialogService')
export class DatePickerDialogService {
    displayOptions;

    constructor(
        @Inject('$mdDialog') private $mdDialog,
        @Inject('$translate') private $translate
    ) {}

    handleOk(date) {
        this.$mdDialog.hide(date);
    }

    handleCancel() {
        this.$mdDialog.cancel();
    }

    show(dialogOptions, datePickerOptions) {
        return this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            controller: () => {
                'ngInject';
            },
            controllerAs: '$ctrl',
            locals: {
                handleCancel: this.handleCancel,
                handleOk: this.handleOk,
                $mdDialog: this.$mdDialog,
                datePickerOptions: angular.copy(datePickerOptions),
                date: undefined
            },
            multiple: true,
            parent: dialogOptions.parentElement,
            targetEvent: dialogOptions.targetEvent,
            template: `
                    <md-dialog class="mw-mini-modal mw-date-picker-modal" aria-label="Select Date Range" layout="column">
                        <mw-mini-modal-dialog
                            class="mw-mini-modal-dialog"
                            ok="{{'OK' | translate}}" cancel="{{'Cancel' | translate}}"
                            no-padding="true"
                            no-title-separator="true"
                            dialog-title="{{'mw-date-picker__dialog-title' | translate}}"
                            layout="column"
                            on-cancel="$ctrl.handleCancel()"
                            on-ok="$ctrl.handleOk($ctrl.date)"
                            is-ok-enabled="$ctrl.date !== undefined">
                            <mw-modal-content>
                                <mw-date-picker
                                    min-view="$ctrl.datePickerOptions.minView"
                                    max-view="$ctrl.datePickerOptions.maxView"
                                    start-view="$ctrl.datePickerOptions.startView"
                                    locale="$ctrl.datePickerOptions.locale"
                                    timezone="$ctrl.datePickerOptions.timezone"
                                    validate="true"
                                    on-select="$ctrl.date = $event.date"
                                >
                                </mw-date-range-picker>
                            </mw-modal-content>
                        </mw-mini-modal-dialog>
                    </md-dialog>
                `
            });
        }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-picker/dialog/date-picker-dialog.service.ts